import React, { useState, useEffect }  from 'react';
import { DataGrid } from '@mui/x-data-grid';
import DatoModificabileInLinea from '../DatoModificabileInLinea';
import CodiceVSVoceCliccabile from '../CodiceVSVoceCliccabile';
import TraduciCiecamente from '../TraduciCiecamente';
import RiciclaCiecamente from '../RiciclaCiecamente';
import stileGrid from '../../interfaccia/stileGrid';
import stilePulsanti from '../../interfaccia/stilePulsanti';

function ListaProdottiBrandEditabileRiciclabile(props) {
  const setProductFunction = props.setProductFunction
  const listaProdottiBrand = props.listaProdottiBrand;
  const tradPermessa = props.tradPermessa;
  //const codiceVSprodCorr = props.codiceVS;
  const utente = props.utente;
  const [rows,setRows] = useState(
    listaProdottiBrand
  )

  useEffect(() => {
    setRows(listaProdottiBrand)
  },[listaProdottiBrand]);

  const columns = [
    {
      field: 'codiceVS',
      headerName: 'VS',
      width: 50,
      headerClassName: "b", // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      renderCell: (params) => {
        /* return <div className="rowitem">{params.row.codiceVS}</div>; */
        if (params.row.codiceVS) { return <CodiceVSVoceCliccabile codiceVS={params.row.codiceVS} setProductFunction={setProductFunction} utente={utente}/> } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'codiceProduttore',
      valueGetter: (params) => params.row.codiceProduttore?.codProduttoreIntero ?? "N/A",
      headerName: 'Cod Intero',
      headerClassName: 'b', // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      width: 175,
      renderCell: (params) => {
        if (params.row.codiceProduttore && params.row.codiceProduttore.codProduttoreIntero) { return <div className="rowitem">{params.row.codiceProduttore.codProduttoreIntero}</div>; } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'codiceProduttore.codProduttoreModello',
      valueGetter: (params) => params.row.codiceProduttore?.codProduttoreModello ?? "N/A",

      headerName: 'Cod Modello',
      headerClassName: 'fw7', // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      width: 300,
      renderCell: (params) => {
        /* return <div className="rowitem">{params.row.codiceProduttore.codProduttoreModello}</div>; */
        if (params.row.codiceProduttore && params.row.codiceProduttore.codProduttoreModello) { return <DatoModificabileInLinea idDocumento={params.row._id} dato={params.row.codiceProduttore.codProduttoreModello} nomeDato="codiceProduttore.codProduttoreModello" setProductFunction={setProductFunction} /> } else { return <DatoModificabileInLinea idDocumento={params.row._id} dato="" nomeDato="codiceProduttore.codProduttoreModello" setProductFunction={setProductFunction}/> }
      }
    },
    {
      field: 'shortName',
      valueGetter: (params) => params.row.shortName?.it ?? "N/A",

      headerName: 'SHORTNAME IT',
      width: 300,
      renderCell: (params) => {
        return <DatoModificabileInLinea idDocumento={params.row._id} dato={params.row.shortName?.it} nomeDato="shortName.it" setProductFunction={setProductFunction} /> /* } */
      }
    },
    {
      field: 'descrizioniSuPS',
      valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.it ?? "N/A",

      headerName: 'Titolo',
      width: 300,
      renderCell: (params) => {
        if (params.row.descrizioniSuPS && params.row.descrizioniSuPS.titolo && params.row.descrizioniSuPS.titolo.it) { return <div className="rowitem">{params.row.descrizioniSuPS.titolo.it}</div>; } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'tradotto',
      valueGetter: (params) => params.row.tradotto.en.toString() ?? "false",

      headerName: 'TR',
      width: 50,
      renderCell: (params) => {
        if (params.row.tradotto && params.row.tradotto.en) { return <div className="rowitem">{params.row.tradotto.en.toString()}</div>; } else { return <div className="rowitem">false</div> }
      }
    },
    { field: 'esportato', headerName: 'EX', width: 50 },
    {
      field: '_id', headerName: 'traduci', width: 75,
      renderCell: (params) => {
        const cambiaStato = function() {
          params.row.tradotto.en = true
          setRows(
            [
              ...rows
            ]
          )
        }
        if (tradPermessa) {
          return (<TraduciCiecamente idProd={params.row._id} trad={params.row.tradotto.en} setProductFunction={setProductFunction} cambiaStato={cambiaStato}/>)
        } else {
          return (<div>{stilePulsanti.bloccoTradAspetto}</div>)
        }
        }
    },
    {
      field: '_id2', headerName: 'ricicla', width: 200,
      renderCell: (params) => {
        const cambiaStato = function (prodotto) {
          setRows((correnti) => correnti.map((row) =>
            row._id === params.row._id ? { ...row, tradotto: prodotto.tradotto } : row
          ));
        };
        return (<RiciclaCiecamente
          idProd={params.row._id}
          trad={params.row.tradotto.en}
          setProductFunction={setProductFunction}
          utente={utente}
          cambiaStato={cambiaStato}
        />)
      }
    },
    {
      field: 'lunghezzaDescLungaIta',
      valueGetter: (params) => params.row.lunghezzaDescLungaIta ?? "false",
      headerName: '#char desc',
      width: 100
    },
    {
      headerName: 'cod per riciclo',
      width: 150,
      renderCell: (params) => {
        if (params.row.lunghezzaDescLungaIta && params.row.codiceProduttore.codProduttoreModello) {
          let tuttiIProdottiConStessoCodiceModello = listaProdottiBrand.filter(prodotto => prodotto?.codiceProduttore?.codProduttoreModello === params.row.codiceProduttore?.codProduttoreModello);
          let numeroCaratteriDescPiuLungaDisponibile = Math.max(...tuttiIProdottiConStessoCodiceModello.map(o => o.lunghezzaDescLungaIta), 0)
          
          if (numeroCaratteriDescPiuLungaDisponibile !== 0) {
            let quelloConLaDescPiuLunga = tuttiIProdottiConStessoCodiceModello.find(prodotto => prodotto.lunghezzaDescLungaIta === numeroCaratteriDescPiuLungaDisponibile && prodotto.codiceVS !== params.row.codiceVS)
            
            if (quelloConLaDescPiuLunga && quelloConLaDescPiuLunga.tradotto.en === true) {
              return (quelloConLaDescPiuLunga.codiceVS)
            } else if (quelloConLaDescPiuLunga) {
              return (quelloConLaDescPiuLunga.codiceVS + " ancora da tradurre!!")
            }
          } else {
            return ("N/P")
          }
        } else if (params.row.lunghezzaDescLungaIta) {
          return ("NO COD")
        }
      }
    }
    /* {
      headerName: 'imposta brand',
      width: 300,
      renderCell: (params) => {
        return(<DatoModificabileInLinea idDocumento={params.row._id} dato="" nomeDato="brand" setProductFunction={setProductFunction} />)
      }
    } */
  ];

  return (
    <div
      className="colonnaTuttaPagina"
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        autoPageSize
        rowsPerPageOptions={[10, 20, 50]}
        pagination
        sx={stileGrid}
      />
    </div>
  )
}


export default ListaProdottiBrandEditabileRiciclabile;
